// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"SearchGenresThemesView__breadCrumbs"};